import { toLanguageCode } from 'js/lib/language';

type ShouldShowTranslationsNotificationBannerParams = {
  subfolderLocaleCode: string | undefined;
  translatedLanguagesCode: string[];
  originalLanguage: string;
};

function shouldShowTranslationsNotificationBanner({
  subfolderLocaleCode,
  originalLanguage,
  translatedLanguagesCode,
}: ShouldShowTranslationsNotificationBannerParams) {
  if (!subfolderLocaleCode) {
    return false;
  }

  // Convert the subfolder locale code to a language code
  const subfolderLanguageCode = toLanguageCode(subfolderLocaleCode);

  // If the original language is not the same as the subfolder language, there is potential to show the banner
  const isDifferentLanguage = subfolderLanguageCode !== originalLanguage;

  // The banner should not be shown if there's an exact match or a language-only match in translated languages
  const hasExactMatch = translatedLanguagesCode.includes(subfolderLocaleCode);
  const hasLanguageOnlyMatch = translatedLanguagesCode.includes(subfolderLanguageCode);

  // Return true only if it's a different language and there's no match
  return isDifferentLanguage && !hasExactMatch && !hasLanguageOnlyMatch;
}

export default shouldShowTranslationsNotificationBanner;
